import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'

export function isSelfServiceRebookAllowed(offer?: App.Offer): boolean {
  if (!offer) return false
  return !!offer.packageUpgradesAllowed && scheduleIsCurrent(offer.onlinePurchaseSchedule)
}
